import { type Events } from '@/common/types/event'
import { type MenuDTOV1 } from '@/common/types/sidebar'

export type NavActionMapKeys = 'header' | 'toolbar'

export interface IObjectKeys {
  [key: string]: string | number
}

export type NavActionResponse = {
  [key in NavActionMapKeys]?: NavActionList
}

export type CreateCasePayload = {
  screenId?: string
  skillGroupId?: string
  timeCounterVisible?: string
  channel: 'default' | 'sms' | 'mail'
}

export type CaseOpenModalPayload = {
  target: string // Modal element id
  action: 'STACK'
}

export type CreateCaseBySpacePayload = {
  skillGroupId: string
  channel: 'sms'
}
export interface NavAction<P> {
  type: string
  text?: string
  key?: string
  role?: string
  actionData?: P
  actions?: NavAction<P>[]
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TextNavAction = Omit<NavAction<any>, 'payload' | 'actions'>

export type NavActionType = {
  'create-case': NavAction<CreateCasePayload>
  'create-customer': TextNavAction
  'create-sms': NavAction<CreateCaseBySpacePayload>
  'show-calendar': TextNavAction
  'case-open-modal': NavAction<CaseOpenModalPayload>
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type NavActionList = NavAction<any>[] // Partial<NavActionType>

export enum NavItemContext {
  Default,
  Root,
  Single,
}

export enum NavItemTypeEnum {
  Event = 'event',
  Link = 'link',
  List = 'list',
  Http = 'http',
  LegacyModal = 'legacy-modal',
  EventModal = 'event-modal',
  ActionModal = 'action-modal',
}

export interface NavItem {
  category?: string
  text: string
  target?: string | keyof Events
  type: NavItemTypeEnum
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload?: any
  children?: NavItem[]
}

export interface NavItemExternal {
  target: ExternalLinkType
  url: string
  name: string
  jwt: boolean
}

export type Menu = {
  general: NavItem[]
  supervision: NavItem[]
  externalLinks: NavItemExternal[]
}

export type ApplicationTag = MenuDTOV1['build']

export enum ExternalLinkType {
  NEW_WINDOW = 'NEWWINDOW',
  CURRENT_TAB = 'CURRENTTAB',
  ANYVALUE = 'ANYVALUE',
}

type ExternalTokenMessage = {
  message: string
  severity: string
}

export type ExternalLinkToken = {
  data: {
    accessToken: string
    refreshToken: string
  }
  messages: Array<ExternalTokenMessage>
  status: string
}
